import { Component } from '@theme/component';

/**
 * Adds calendar days in the visitor's local timezone, including DST transitions.
 * @param {number} offset
 * @param {Date} [today]
 * @returns {string}
 */
export function relativeBatchDate(offset, today = new Date()) {
  const date = new Date(today);
  date.setDate(date.getDate() + offset);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  }).format(date);
}

class BatchShippingNotice extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.dataset.dateMode !== 'visitor_relative') return;

    const offset = Number(this.dataset.dateOffset);
    if (!Number.isInteger(offset) || offset < 0 || offset > 30) return;
    const date = relativeBatchDate(offset);
    // Update both accessible text and its visual duplicate over the progress fill.
    for (const target of this.querySelectorAll('[data-relative-batch-date]')) {
      target.textContent = date;
    }
  }
}

if (!customElements.get('batch-shipping-notice')) {
  customElements.define('batch-shipping-notice', BatchShippingNotice);
}
